// extracted by mini-css-extract-plugin
export default {"caption":"Caption_caption__nRdD8"};